import '@vueform/multiselect/themes/default.css';
import './../styles/style.scss';

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('nojs');
});
